import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "ItemSpecItems";

type ItemDataParams = {
  item: string;
  copyItem?: string;
  IsDataTransNeeded?: boolean;
  IsIncludeAllLocations?: boolean;
};

export const getDataForItem = async (params: ItemDataParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetDataForItem`,
    undefined,
    params
  );
};
